export const paths = ['/request-information'];
